module.exports = __webpack_public_path__ + "img/banner.00e7c9e5.png";